import { useSelector, useDispatch } from "react-redux";
import toast from "react-hot-toast";
import {
  WheelIcon,
  BusIcon2,
  GspIcon,
  GalleryIcon,
  ChatIcon,
  BookIcon,
} from "assets/icons";
import Seat from "components/seat";
import {
  setBooking,
  setTicketActiveStep,
} from "../../redux/reducers/bookingReducer";

function Step1({ busLayout }) {
  const dispatch = useDispatch();
  const { busDetail, booking } = useSelector((state) => state.bookingReducer);
  const benefits = [
    {
      label: "Why book this bus?",
      icon: <BusIcon2 />,
    },
    {
      label: "Boarding / Dropping",
      icon: <GspIcon />,
    },
    {
      label: "Amenties & Photos",
      icon: <GalleryIcon />,
    },
    {
      label: "Ratings & Reviews",
      icon: <ChatIcon />,
    },
    {
      label: "Booking Policies",
      icon: <BookIcon />,
    },
  ];

  const selectSeat = (seat, type) => {
    const seatIndex = booking.passengerData.findIndex(
      (passenger) => passenger.seat_no === seat.seat_number
    );

    let updatedPassengerData;

    if (seatIndex > -1) {
      // Seat exists, remove it
      updatedPassengerData = booking.passengerData.filter(
        (passenger) => passenger.seat_no !== seat.seat_number
      );
    } else {
      // Seat does not exist, add it
      updatedPassengerData = [
        ...booking.passengerData,
        {
          seat_no: seat.seat_number,
          seat_type: type,
        },
      ];
    }
    dispatch(
      setBooking({
        ...booking,
        passengerData: updatedPassengerData,
      })
    );
  };

  const isSeatSelected = (seatNumber) => {
    return booking.passengerData.some(
      (passenger) => passenger.seat_no === seatNumber
    );
  };

  const handleProceed = () => {
    if (!booking?.passengerData?.length) {
      toast.error("Please select at least one seat.");
      return;
    }
    const targetDiv = document.getElementById("ticketStep2");
    if (targetDiv) {
      targetDiv.scrollIntoView({ behavior: "smooth" });
    }
    dispatch(setTicketActiveStep(2));
  };

  return (
    <div>
      <div className="w-full flex flex-col md:flex-row gap-8 md:gap-12 px-5 md:px-10 py-8 md:py-12">
        <div className="w-full flex flex-col gap-5">
          {busLayout?.lower_layout?.length > 0 && (
            <div className="w-full flex flex-col bg-white shadow-cityCard items-center py-6 sm:py-10 px-5 sm:px-10">
              <div className="w-full flex items-center">
                <div className="flex-1 text-[12px] sm:text-sm text-[#112211]">
                  Lower Berth
                </div>
                <div className="h-[20px] w-[20px]">
                  <WheelIcon />
                </div>
              </div>
              <div className="w-full h-[0.5px] bg-[#858585] my-5 md:my-6" />
              <div className="w-full flex flex-col gap-3.5">
                {busLayout?.lower_layout.map((row, index) => (
                  <div key={index} className="w-full grid grid-cols-4 gap-3.5">
                    {row.map((item, idx) => (
                      <>
                        {item.seat_number ? (
                          <Seat
                            key={idx}
                            label={item.seat_number}
                            status={
                              item.is_booked
                                ? "booked"
                                : isSeatSelected(item.seat_number)
                                ? "selected"
                                : "available"
                            }
                            onClick={() => selectSeat(item, "lower")}
                          />
                        ) : (
                          <div key={idx} className="opacity-0 invisible" />
                        )}
                      </>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
          {busLayout?.upper_layout?.length > 0 && (
            <div className="w-full flex flex-col bg-white shadow-cityCard items-center py-6 sm:py-10 px-5 sm:px-10">
              <div className="w-full flex items-center">
                <div className="flex-1 text-[12px] sm:text-sm text-[#112211]">
                  Upper Berth
                </div>
                <div className="h-[20px] w-[20px]">
                  <WheelIcon />
                </div>
              </div>
              <div className="w-full h-[0.5px] bg-[#858585] my-5 md:my-6" />
              <div className="w-full flex flex-col gap-3.5">
                {busLayout?.upper_layout.map((row, index) => (
                  <div key={index} className="w-full grid grid-cols-4 gap-3.5">
                    {row.map((item, idx) => (
                      <>
                        {item.seat_number ? (
                          <Seat
                            key={idx}
                            label={item.seat_number}
                            status={
                              item.is_booked
                                ? "booked"
                                : isSeatSelected(item.seat_number)
                                ? "selected"
                                : "available"
                            }
                            onClick={() => selectSeat(item, "upper")}
                          />
                        ) : (
                          <div key={idx} className="opacity-0 invisible" />
                        )}
                      </>
                    ))}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="w-full md:max-w-[190px] flex flex-col">
          <div className="text-sm sm:text-base font-semibold text-[#112211] mb-5 sm:mb-8">
            Know about seat types
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:flex flex-col gap-8">
            <div className="w-full flex items-center gap-3.5">
              <div className="flex flex-col items-center">
                <div className="bg-[#E8E8E8] w-[27px] h-[23px] rounded-[5px] z-[2] -mb-3"></div>
                <div className="bg-[#C8C8C8] w-[38px] h-[23px] rounded-[5px] z-0"></div>
              </div>

              <div className="text-[12px] font-medium text-[#112211]">
                Available
              </div>
            </div>
            <div className="w-full flex items-center gap-3.5">
              <div className="flex flex-col items-center">
                <div className="bg-[#717171] w-[27px] h-[23px] rounded-[5px] z-[2] -mb-3"></div>
                <div className="bg-[#5A5555] w-[38px] h-[23px] rounded-[5px] z-0"></div>
              </div>
              <div className="text-[12px] font-medium text-[#112211]">
                Booked by others
              </div>
            </div>
            <div className="w-full flex items-center gap-3.5">
              <div className="flex flex-col items-center">
                <div className="bg-[#D62423] w-[27px] h-[23px] rounded-[5px] z-[2] -mb-3"></div>
                <div className="bg-[#B00000] w-[38px] h-[23px] rounded-[5px] z-0"></div>
              </div>
              <div className="text-[12px] font-medium text-[#112211]">
                Selected by you
              </div>
            </div>
            <div className="w-full flex items-center gap-3.5">
              <div className="flex flex-col items-center">
                <div className="bg-[#F890BB] w-[27px] h-[23px] rounded-[5px] z-[2] -mb-3"></div>
                <div className="bg-[#EB669E] w-[38px] h-[23px] rounded-[5px] z-0"></div>
              </div>
              <div className="text-[12px] font-medium text-[#112211]">
                Booked by female passenger
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full grid grid-cols-3 gap-4 md:flex items-center justify-between bg-white shadow-block py-4 px-5 mb-8">
        {benefits.map((item, index) => (
          <div
            key={index}
            className="max-w-[60px] flex flex-col items-center gap-2"
          >
            <div className="h-7 w-7 rounded-full flex items-center justify-center bg-primary-700">
              <span className="text-white h-4 w-4">{item.icon}</span>
            </div>
            <div className="text-[10px] text-center text-[#112211] font-medium">
              {item.label}
            </div>
          </div>
        ))}
      </div>
      <div className="grid grid-cols-1 gap-6 md:gap-0 md:flex items-start justify-between px-5 md:px-12 mb-6 sm:mb-8">
        <div className="lg:max-w-[180px] flex items-center flex-wrap text-sm text-[#5A5D63] font-medium">
          Upper Seat :
          {booking.passengerData.map((item) => {
            if (item.seat_type === "upper") {
              return (
                <>
                  <span className="font-semibold">
                    {item.seat_no}
                    <span>,&nbsp;</span>
                  </span>
                </>
              );
            }
          })}
        </div>
        <div className="lg:max-w-[180px] flex items-center flex-wrap text-sm text-[#5A5D63] font-medium">
          Lower Seat :
          {booking.passengerData.map((item) => {
            if (item.seat_type === "lower") {
              return (
                <>
                  <span className="font-semibold">
                    {item.seat_no}
                    <span>,&nbsp;</span>
                  </span>
                </>
              );
            }
          })}
        </div>
        <div className="flex flex-col">
          <div className="text-sm font-semibold text-[#1D1D1D]">{`RM ${
            booking?.passengerData.length * busDetail?.bus_rate
          }`}</div>
          <div className="text-[12px] text-[#1D1D1D]">(Exlusive of Taxes)</div>
        </div>
      </div>
      <div className="px-5 md:px-12 pb-10 sm:pb-8">
        <button
          onClick={handleProceed}
          className="w-full h-[48px] px-4 py-3 bg-primary-700 flex items-center justify-center rounded-[4px] text-sm font-semibold text-white"
        >
          Proceed
        </button>
      </div>
    </div>
  );
}
export default Step1;
